import { CouponsInput, CouponsOutput } from "@/interfaces/coupons";
import { BaseService } from "./BaseService";

export class CouponsService extends BaseService<CouponsInput, CouponsOutput> {
  constructor() {
    super();
    this.path = "coupons";
  }
}
